<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat" style="width:1000px;">
            <h3 class="mb-0">MAKLUMAT RASIONALISASI TAHUN 2016</h3>
            <br />
            <div class="pl-lg-2">
                <validation-provider name="Tarikh Pergerakan Gaji" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg="5"> Sila Pilih </b-col>
                        <b-col lg="1">:</b-col>
                        <b-col sm="6">
                            <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio v-model="Obj.StatusCatatan" :aria-describedby="ariaDescribedby" name="some-radios" value="1">Pemindahan Gaji Gred 11, 13 & 19</b-form-radio>
                                <b-form-radio v-model="Obj.StatusCatatan" :aria-describedby="ariaDescribedby" name="some-radios" value="2">Urusan Pertukaran Pelantikan PP01/2016 Selain Gred 11,13 & 19</b-form-radio>
                                <b-form-radio v-model="Obj.StatusCatatan" :aria-describedby="ariaDescribedby" name="some-radios" value="3">Pemindahan Gaji Bersamaan 1 KGT </b-form-radio>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                
                <div v-if="Obj.StatusCatatan==1">
                    <validation-provider name="Amaun Gaji Permulaan" :rules="{ required: true }" v-slot="validationContext">
                        <b-row class="my-1">
                            <b-col lg="5"> Amaun Gaji Permulaan GPT pada 1 Julai 2016 * </b-col>
                            <b-col lg="1">:</b-col>
                            <b-col lg="6">
                                <b-form-input v-model="Obj.SalGrd" :state="getValidation(validationContext)"></b-form-input>
                            </b-col>
                        </b-row>
                    </validation-provider>
                    <br />
                    <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                        <b-row class="my-1">
                            <b-col lg='5'>Tarikh Kuatkuasa</b-col>
                            <b-col lg='1'>:</b-col>
                            <b-col lg='4'>
                                <b-form-input v-model="Obj.EftDate" :state="getValidation(validationContext)" readonly></b-form-input>
                            </b-col>
                        </b-row>
                    </validation-provider>
                </div>
                <div v-if="Obj.StatusCatatan==2">
                    <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                        <b-row>
                            <b-col lg="5"> Klasifikasi Perkhidmatan</b-col>
                            <b-col lg="1"> :</b-col>
                            <b-col lg="6">
                                <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.ServClassId" :options="ServClassList" @change="runMethod()" style="width: 100%" aria-describedby="input-2-live-feedback">
                                    <template #first>
                                        <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                    </validation-provider>
                    <br />
                    <validation-provider name="Skim Perkhidmatan Tukar Lantik" :rules="{ required: true }" v-slot="validationContext">
                        <b-row>
                            <b-col lg="5"> Skim Perkhidmatan</b-col>
                            <b-col lg="1"> :</b-col>
                            <b-col lg="6">
                                <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.SchmOfServId" :options="SchmOfServList" @change="runMethod2()" style="width: 100%" aria-describedby="input-2-live-feedback">
                                    <template #first>
                                        <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                    </validation-provider>
                    <br />
                    <validation-provider name="Gred Jawatan Tukar Lantik" :rules="{ required: true }" v-slot="validationContext">
                        <b-row class="my-1">
                            <b-col lg="5"> Gred Jawatan</b-col>
                            <b-col lg="1">:</b-col>
                            <b-col lg="6">
                                <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="Obj.SalGrdID" :options="SalGrdList" style="width: 40%" aria-describedby="input-2-live-feedback">
                                    <template #first>
                                        <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                    </validation-provider>
                    <br />
                    <validation-provider name="Amaun Gaji Permulaan" :rules="{ required: true }" v-slot="validationContext">
                        <b-row class="my-1">
                            <b-col lg="5"> Amaun Gaji Tukar Lantik * </b-col>
                            <b-col lg="1">:</b-col>
                            <b-col lg="6">
                                <b-form-input v-model="Obj.SalGrd" :state="getValidation(validationContext)"></b-form-input>
                            </b-col>
                        </b-row>
                    </validation-provider>
                    <br />
                    <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                        <b-row class="my-1">
                            <b-col lg='5'>Tarikh Kuatkuasa</b-col>
                            <b-col lg='1'>:</b-col>
                            <b-col lg='4'>
                                <b-form-input v-model="Obj.EftDate" :state="getValidation(validationContext)" readonly></b-form-input>
                            </b-col>
                        </b-row>
                    </validation-provider>
                </div>
                <div v-if="Obj.StatusCatatan==3">
                    <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                        <b-row class="my-1">
                            <b-col lg='5'>Tarikh Kuatkuasa</b-col>
                            <b-col lg='1'>:</b-col>
                            <b-col lg='4'>
                                <b-form-input v-model="Obj.EftDate" :state="getValidation(validationContext)" readonly></b-form-input>
                            </b-col>
                        </b-row>
                    </validation-provider>
                </div>
                <br />
                <validation-provider name="Amaun Dalam Buku Servis" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col sm="5"> Amaun Dalam Buku Servis </b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="6">
                            <b-form-input id="AmaunTelahTerima" v-model="Obj.AmaunTelahTerima" ></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Catatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row>
                        <b-col sm="5"> Catatan </b-col>
                        <b-col sm="1"> :</b-col>
                        <b-col sm="6">
                            <!-- <b-form-input v-model="Obj.Catatan" :state="getValidation(validationContext)" class="custom-input"></b-form-input> -->
                            <b-form-textarea v-model="Obj.Catatan" class="custom-input" rows="4" maxlength="1000" placeholder="Masukkan catatan (maksimum 1000 aksara)"></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>

                <br />
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit">SIMPAN</b-button>
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button> -->
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="nextPapar()">PAGE PAPAR</b-button> -->

                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun", "elemenId"],
    data() {
        return {

            Obj: {
                EftDate: "01-07-2016",
                Catatan: `Rasionalisasi Skim Perkhidmatan.
Penambahbaikan JGMM dan pemberian pemindahan gaji bersamaan 1 KGT berdasarkan PP Bil. 3/2016.`,
            },
            StatusCatatan: 1,
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            tpgList: [],
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },

        runMethod() {
            console.log(this.ServClassId);

            let Search = {
                ServClassId: this.Obj.ServClassId,
            };

            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {
            console.log("this SchmOfServId", this.SchmOfServId);
            let Search2 = {
                ServClassId: this.Obj.ServClassId,
                SchmOfServId: this.Obj.SchmOfServId,
            };
            console.log("this Search2", this.Search2);
            GetselenggaraService.getSenaraiSalGrd(Search2)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        SimpanMaklumat() {
            this.Obj.coid = Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;
            this.Obj.elemenId = this.elemenId;
            console.log("log", this.Obj);

            GetsalaryService.setElemen2016(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {

                console.log("StatusSimpan", this.StatusSimpan);

                if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "KLIK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "KLIK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("batal");
                    });
                }
            });
        }

    },
    created() {

        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

    }
}
</script>

<style>
input[type="radio"] {
    margin-right: 0;
}
</style>
